import { useTranslation } from "react-i18next";
import { Award, Repeat, Lock, Palmtree } from "lucide-react";

export default function About() {
  const { t } = useTranslation();
  const values = [
    { icon: Award, title: t("why.quality"), text: t("why.qualityText") },
    { icon: Repeat, title: t("why.flex"), text: t("why.flexText") },
    { icon: Lock, title: t("why.security"), text: t("why.securityText") },
  ];
  return (
    <div className="section-sand min-h-screen">
      <section className="relative h-72 flex items-center">
        <img src="https://images.unsplash.com/photo-1580223530509-849e0ad583ca?w=1600&q=80" alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 hero-gradient" />
        <div className="relative max-w-4xl mx-auto px-6 text-white">
          <h1 className="font-heading font-extrabold text-4xl sm:text-5xl">{t("nav.about")}</h1>
          <p className="text-pastel font-body mt-3 max-w-xl">{t("footer.tagline")}</p>
        </div>
      </section>
      <div className="max-w-4xl mx-auto px-6 py-16">
        <p className="text-lg text-ink font-body leading-relaxed">
          Caribbean Drive connecte les voyageurs aux meilleurs loueurs locaux de la Caraïbe. Notre mission : rendre la
          location de véhicule simple, transparente et sûre, de la Martinique à Sint Maarten. Chaque loueur partenaire est
          vérifié (KYC Stripe Connect) et chaque paiement est sécurisé.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
          {values.map((v, i) => (
            <div key={i} className="bg-white rounded-2xl p-6 shadow-card border border-border">
              <v.icon className="w-8 h-8 text-canard mb-3" />
              <h3 className="font-heading font-bold text-lg text-ink">{v.title}</h3>
              <p className="text-muted2 font-body text-sm mt-2">{v.text}</p>
            </div>
          ))}
        </div>
        <div className="mt-12 bg-canard-dark rounded-3xl p-10 text-center text-white relative overflow-hidden">
          <Palmtree className="absolute right-4 bottom-4 w-32 h-32 text-emeraude/20" />
          <h2 className="font-heading font-bold text-2xl relative z-10">4 destinations · 1 plateforme</h2>
          <p className="text-pastel font-body mt-2 relative z-10">Martinique · Guadeloupe · Saint-Martin · Sint Maarten</p>
        </div>
      </div>
    </div>
  );
}
